<template>
  <div class="page block">
    <div class="page__wrapper block-wrapper" style="padding-top: 30px">
      <div class="p-grid">
        <template v-if="webForm">
          <div v-for="(screen, i) of webForm.screens" :key="i">
            <template v-if="page === screen.step">
              <h3 v-if="screen.title" class="form-title col-12">
                {{ screen.title }}
              </h3>
              <h4 v-if="screen.subTitle" class="form-subtitle col-12">
                {{ screen.subTitle }}
              </h4>
              <div v-if="screen.description" class="form-description col-12">
                {{ screen.description }}
              </div>

              <div class="col-12" v-for="element of screen.elements" :key="element.id">
                <template v-if="element.code === 'location'">
                  <InputLocation v-model="location"
                                 :label="element.title"
                                 :locations="locations"
                                 :validator="$v.location"
                                 @input="onChangeLocation"
                  />
                </template>

                <template v-if="element.code === 'menuItem'">
                  <InputQueue v-model="menuItem"
                              :label="element.title"
                              :queues="menu"
                              :validator="$v.menuItem"
                              :placeholder="placeholderMenu"
                              :disabled="disableMenu"
                              @input="onChangeQueue"
                  />
                </template>

                <template v-if="element.code === 'day'">
                  <InputDate v-model="day"
                             :label="element.title"
                             :validator="$v.day"
                             :disabled="disableDate"
                             :location="location"
                             :queue="queue"
                             :apiKey="apiKey"
                             @date-select="onChangeDay"
                  />
                </template>

                <template v-if="element.code === 'times'">
                  <InputTime v-model="times"
                             :label="element.title"
                             :schedules="schedules"
                             :day="day"
                             :validator="$v.times"
                             :scheduleErrorMessage.sync="scheduleErrorMessage"
                  />
                </template>

                <template v-if="element.code === 'name'">
                  <InputName v-model.trim="name" :label="element.title" :validator="$v.name" @input="inputName"/>
                </template>

                <template v-if="element.code === 'phone'">
                  <InputPhone v-model="phone"
                              :validator="$v.phone"
                              :label="element.title"
                              :disabled="scheduleError"
                              @input="inputPhone"
                              @focus="focusPhone"
                  />
                </template>

                <template v-if="element.code === 'email'">
                  <InputEmail v-model.trim="email"
                              :validator="$v.email"
                              :label="element.title"
                              :disabled="scheduleError"
                              @input="inputEmail"
                              @focus="focusEmail"
                  />
                </template>

                <template v-if="element.code === 'comment'">
                  <InputComment v-model.trim="comment" :label="element.title"/>
                </template>

                <template v-if="element.code === 'captcha' && !scheduleError">
                  <InputCaptcha v-model="captcha"
                                :label="element.title"
                                :validator="$v.captcha"
                                :captchaUrl="captchaUrl"
                                :errorMessage="captchaErrorMessage"
                                @input="inputCaptcha"
                                @captchaRefresh="captchaRefresh"
                  />
                </template>

                <template v-if="element.code === 'personalData'">
                  {{ element.label }}
                  <InputPersonalData v-model="personalData"
                                     :label="element.title"
                                     :validator="$v.personalData"
                                     @input="inputPersonalDataAgreementValue"
                  />
                </template>
              </div>
            </template>
          </div>
          <template v-if="showConfirmPage && isGenerateCode">
            <div class="col-12" v-if="phoneConfirm">
              <InputConfirmCode
                v-model.trim="confirmPhone"
                :title="$t('preRegistration.confirmPhone')"
                :disabled="disableConfirmPhone && confirmPhone !== null"
                :generateCodeDisable.sync="generateCodePhoneDisable"
                :generateCodeDisableTime="generateCodePhoneDisableTime"
                :errorMessage="confirmPhoneErrorMessage"
                :infoResendSms="infoResendSms"
                @resendCode="resendCode('phone')"
                @input="inputConfirmPhoneCode"
              />
            </div>

            <div class="col-12" v-if="emailConfirm">
              <InputConfirmCode
                v-model.trim="confirmEmail"
                :title="$t('preRegistration.confirmEmail')"
                :disabled="disableConfirmEmail && confirmEmail !== null"
                :generateCodeDisable.sync="generateCodeEmailDisable"
                :generateCodeDisableTime="generateCodeEmailDisableTime"
                :errorMessage="confirmEmailErrorMessage"
                :infoResendSms="infoResendEmail"
                @resendCode="resendCode('email')"
                @input="inputConfirmEmailCode"
              />
            </div>
          </template>
        </template>

        <div class="col-12 group-button">
          <Button
            class="button-registration button-registration-left"
            :label="$t('preRegistration.prev')"
            @click="prevPage" v-if="showPreButton"
          />

          <Button
            v-if="showNextButton"
            class="button-registration"
            style="margin-left: auto"
            :label="$t('preRegistration.next')"
            :disabled="validateButton"
            @click="nextPage"
          />

          <Button
            v-if="showSaveButton"
            class="button-registration"
            :label="$t('preRegistration.registration')"
            :disabled="validateButton"
            @click="save"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FormRegistratorController from '@/views/form/form-registrator-controller'

export default {
  name: 'FormRegistrator',
  mixins: [FormRegistratorController]
}

</script>

<style scoped>
  .form-title {
    margin: 0;
    overflow-wrap: break-word;
  }
  .form-subtitle {
    margin: 0;
    overflow-wrap: break-word;
  }
  .form-description {
    margin: 0;
    overflow-wrap: break-word;
    padding-bottom: 30px;
  }
</style>
